class TrackingLocationMapper {
  static createModelFromResponse(data) {
    if (!data) {
      return undefined;
    }
    return {
      alpha2Code: data.country_code,
      state: data.state,
      zipCode: data.postal_code,
      city: data.city,
      location: data.location,
      coordinates: data.coordinates
    };
  }
}

export { TrackingLocationMapper };
//# sourceMappingURL=TrackingLocationMapper.js.map
